import { formatAddress } from '@/common/utils/address';
import { getFullName } from '@/common/utils/person';
import type { CoreRequest } from '$api-clients/hooks';
import type { Lease, RawResult, RawResults, SearchResult } from './types';

type LeaseResult = RawResult & {
  interaction: Lease;
};

function formatContacts(
  contacts: RawResults[number]['interaction']['contacts'],
) {
  const clientContacts =
    contacts?.filter((contact) => contact?.type === 'client') ?? [];

  return clientContacts
    .map((contact) => getFullName(contact.firstName, contact.lastName))
    .join(', ');
}

export function buildListingsSearchResult(
  rawResults: CoreRequest<'/listings'>['Data']['results'],
): SearchResult[] {
  return rawResults.map((item) => ({
    type: 'listings',
    id: item.id,
    address: formatAddress(item.property, { includeStreet2: true }),
    contacts: formatContacts(item.contacts),
  }));
}

export function buildOffersSearchResult(
  rawResults: CoreRequest<'/offers'>['Data']['results'],
): SearchResult[] {
  return rawResults.map((item) => ({
    type: 'offers',
    id: item.id,
    address: formatAddress(item.listing?.property, { includeStreet2: true }),
    contacts: formatContacts(item.contacts),
  }));
}

export function buildLeaseSearchResult(rawResults: RawResults): SearchResult[] {
  return rawResults
    .filter((item): item is LeaseResult => item.type === 'lease')
    .map((item) => ({
      type: 'leases',
      id: item.id,
      address: formatAddress(item.interaction.listing?.property, {
        includeStreet2: true,
      }),
      contacts: formatContacts(item.interaction.contacts),
      representation: item.interaction.representation,
    }));
}
